import React from "react";
import { Button } from "./ui/button";
import { useParams, useNavigate } from "react-router";

import useProjectActions from "../hooks/useProjectActions";
import Modal from "../Modal";
import useFirebaseProject from "../hooks/useFirebaseProject";

const MaterialDeletePage = () => {
  const { project_id, material_id } = useParams();
  const navigate = useNavigate();
  const { editProject } = useProjectActions();
  const project = useFirebaseProject(project_id!);

  const handleDelete = () => {
    const new_project = { ...project };
    delete new_project.materials![material_id!];
    editProject(project_id!, new_project);
  };

  const actions = () => (
    <React.Fragment>
      <Button
        variant="destructive"
        onClick={() => {
          handleDelete();
        }}
      >
        Delete
      </Button>
      <Button variant="outline" onClick={() => navigate(-1)}>Cancel</Button>
    </React.Fragment>
  );

  const renderContent = () => {
    if (!project) {
      return <div>Loading...</div>;
    }

    return (
      <React.Fragment>
        {project?.materials && project?.materials[material_id!]?.glass_reference ? (
          <div>Glass:{project?.materials[material_id!]?.glass_reference}</div>
        ) : (
          <div>
            Description:
            {project?.materials && project?.materials[material_id!]?.description}
          </div>
        )}
      </React.Fragment>
    );
  };

  return (
    <Modal
      title="Delete Material"
      content={renderContent()}
      actions={actions()}
      onDismiss={() => navigate(-1)}
    />
  );
};

export default MaterialDeletePage;
